export default __webpack_public_path__ + "static/media/group-white.a4e0f372.svg";